const GENDERS = [
    {
        value: "M",
        text: "Male",
    },
    {
        value: "F",
        text: "Female",
    },
];

export default GENDERS;
